import { render, staticRenderFns } from "./loading-component.vue?vue&type=template&id=0f55bd35&"
import script from "./loading-component.vue?vue&type=script&lang=js&"
export * from "./loading-component.vue?vue&type=script&lang=js&"
import style0 from "./loading-component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports